<template>
  <section class="text-center">
    <v-progress-circular indeterminate color="secondary"></v-progress-circular>
    <div class="text-h6">{{ loadingText }}</div>
  </section>
</template>

<script>
export default {
  props: {
    loadingText: {
      type: String,
      default: 'Cargando...',
    },
  },
}
</script>
